import sum from 'lodash/sum';
import { number } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

import SignedCurrencyFormat from '../../generic/SignedCurrencyFormat';
import { calculateTotalSum } from '../../invoices/utils';
import { isInvoiceStatusNotCanceled } from '../utils';

function Sums({ sumBookingEntries, sumInvoices, netClientBudget }) {
  return (
    <Row className="pt-2 c-balance-line">
      <Col sm={7} />
      <Col sm={1} className="px-0">
        {!!netClientBudget && (
          <>
            <SignedCurrencyFormat
              className="text-muted"
              name="netClientBudget"
              value={netClientBudget}
            />
            <div className="small text-muted">Campaign Net Budget</div>
          </>
        )}
      </Col>
      <Col sm={2}>
        <SignedCurrencyFormat
          name="sumBookingEntries"
          value={sumBookingEntries}
        />
        <div className="small text-muted">Remaining to be invoiced</div>
      </Col>
      <Col sm={2} className="px-0">
        <SignedCurrencyFormat name="sumInvoices" value={sumInvoices} />
        <div className="small text-muted">Already invoiced</div>
      </Col>
    </Row>
  );
}

Sums.propTypes = {
  sumBookingEntries: number.isRequired,
  netClientBudget: number.isRequired,
  sumInvoices: number.isRequired,
};

function calculateInvoiceSum(invoices) {
  const uncanceledInvoices = invoices.filter(invoice =>
    isInvoiceStatusNotCanceled(invoice.status),
  );
  return sum(
    uncanceledInvoices.map(invoice =>
      calculateTotalSum(invoice.bookingEntries),
    ),
  );
}

export { Sums as SumsComponent };
export default connect(({ balance }, { opportunity }) => {
  if (balance.context.opportunityId !== opportunity.id) {
    return { sumBookingEntries: 0, sumInvoices: 0 };
  }

  const { invoices, bookingEntries } = balance;
  return {
    sumBookingEntries: calculateTotalSum(bookingEntries),
    sumInvoices: calculateInvoiceSum(invoices),
  };
})(Sums);
